import React, { FC } from "react";
import { Accordion, AccordionSummary, Grid, Paper, Divider, Tooltip, IconButton, colors } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { trafficLight } from "../../theme";


interface ISokProps {
    name: string,
    values: string[],
    colors: string[]

}

const SummaryLegend: FC<ISokProps> = ({ name, values, colors }) => {
    return (<>
        <div style={{ padding: '7px',  }}>
            <Divider style={{marginBottom:'10px'}} />
            <Grid container>
                <Grid item xs={3} style={{ textAlign: 'left', fontSize: '12px',display: 'flex', alignItems:'center' }}><strong>{name}</strong></Grid>
                <Grid item xs={9} style={{ display: 'flex', flexWrap:'wrap', alignItems: 'center', justifyContent: 'left', width: '100%' }}>

                    {values.map((value, index) => {
                        return (
                            <> 
                            <div style={{ display: 'flex', flexWrap:'wrap', alignItems: 'center', justifyContent: 'left'}}>
                                <div style={{ width: '15px', height: '15px', backgroundColor: colors[index], borderRadius: '50%', marginRight: '5px', whiteSpace: 'nowrap' }}></div>
                                <div style={{ paddingRight: '10px', fontSize: '12px', whiteSpace: 'nowrap' }}>{value}</div>
                            </div>
                            </>)
                    })}




                </Grid>
            </Grid>
        </div>



    </>)

}


export default SummaryLegend;